import { syncContactsWithCache } from "../../state/actions/contacts";
import store from "../../state/configureStore";
import ContactsServiceClient from "./ContactsServiceClient";
import {
	getDataFromLFStorage,
	LFStorageKeys,
	saveDataInLFStorage,
} from "../storage/LFStorage";

export function search(searchKey, selectedDomain) {
	return ContactsServiceClient.searchContacts({
		queryString: searchKey,
		selectedDomain: selectedDomain,
	}).then((data) => {
		const { content: contacts } = data;
		return contacts || [];
	});
}

export function addContacts(data, type, selectedDomain) {
	if (type === "search") {
		return ContactsServiceClient.addContact(
			{
				userIds: data,
				selectedDomain: selectedDomain,
			},
			true
		).then((data) => {
			const { error } = data;
			if (error && error !== 0) {
				throw new Error();
			}
		});
	}

	if (type === "form") {
		return ContactsServiceClient.addContact({
			localContacts: data,
			selectedDomain:selectedDomain
		}).then((data) => {
			const { error } = data;
			if (error && error !== 0) {
				throw new Error();
			}
		});
	}
}

export async function updateLocalContact(data, selectedDomain) {
	return ContactsServiceClient.updateContact({
		localContacts: data,
		selectedDomain: selectedDomain
	}).then((data) => {
		const { error } = data;
		if (error && error !== 0) {
			throw new Error();
		}
	});
}

export async function inviteByEmail(emails, selectedDomain) {
	return ContactsServiceClient.inviteContacts({
		emailIds: emails,
		selectedDomain: selectedDomain,
	}).then((data) => {
		const { error } = data;
		if (error && error !== 0) {
			throw new Error();
		}
	});
}

export async function removeContacts(users, type, selectedDomain) {
	if (type === "local") {
		return ContactsServiceClient.removeContact({ localContacts: [users], selectedDomain: selectedDomain }).then(
			async (data) => {
					const { error } = data;
					if (error && error !== 0) {
						throw new Error();
					}
					let contactsList =
						(await getDataFromLFStorage(
							`${LFStorageKeys.CONTACTS}_${selectedDomain}`
						)) || [];

					if (contactsList) {
						contactsList.localContacts = contactsList?.localContacts?.filter(
							(contact) => users.userId !== contact.userId
						);
						saveDataInLFStorage(
							`${LFStorageKeys.CONTACTS}_${selectedDomain}`,
							contactsList
						);
						store.dispatch(syncContactsWithCache(contactsList));
					}
			}
		);
	}
	return ContactsServiceClient.removeContact({ userIds: users, selectedDomain: selectedDomain }).then(async (data) => {
		const { error } = data;
		if (error && error !== 0) {
			throw new Error();
		}
		let contactsList =
			(await getDataFromLFStorage(
				`${LFStorageKeys.CONTACTS}_${selectedDomain}`
			)) || [];

		if (contactsList) {
			contactsList.contacts = contactsList?.contacts?.filter(
				(contact) => !users.includes(contact.userId)
			);
			saveDataInLFStorage(
				`${LFStorageKeys.CONTACTS}_${selectedDomain}`,
				contactsList
			);
			store.dispatch(syncContactsWithCache(contactsList));
		}
	});
}

export async function acceptContacts(users, selectedDomain) {
	return ContactsServiceClient.acceptContact({ userIds: users, selectedDomain: selectedDomain }).then((data) => {
		const { error } = data;
		if (error && error !== 0) {
			throw new Error();
		}
	});
}

export async function ignoreContacts(users, selectedDomain) {
	return ContactsServiceClient.ignoreContact({ userIds: users, selectedDomain: selectedDomain }).then((data) => {
		const { error } = data;
		if (error && error !== 0) {
			throw new Error();
		}
	});
}
